module.exports = __webpack_public_path__ + "img/Pekao.e36a80c3.png";